import applyConsentStringsToNodes from './applyConsentStringsToNodes'

export default applyConsentStringsToNodes
